// extracted by mini-css-extract-plugin
export default {"page":"Contact_page__GPNpz","container":"Contact_container__TrGCv"};